import { Compiler } from './Compiler';
import { AggFormula } from './Forms/AggFormula';
import { DateFormula } from './Forms/DateFormula';
import { FieldFormula } from './Forms/FieldFormula';
import { GenericFormula } from './Forms/GenericFormula';
import { NTileFormula } from './Forms/NTileFormula';
import { FFieldResolver } from './FormulaField';
import { FFuncResolver } from './FormulaFunc';
import { FTypeResolver } from './FormulaType';
import { Tree } from './Parser/Node';
export class FFactory {
    constructor(fields, funcs, types) {
        this._fields = fields;
        this._funcs = funcs;
        this._types = types;
    }
    get fields() {
        return this._fields;
    }
    get funcs() {
        return this._funcs;
    }
    get types() {
        return this._types;
    }
    compile(source) {
        const tree = Tree.Parse(source);
        const fields = new FFieldResolver(this.fields);
        const funcs = new FFuncResolver(this.funcs);
        const types = new FTypeResolver(fields, funcs, this.types);
        return this.compileFormula(tree, new Compiler(fields, funcs, types));
    }
    validate(source) {
        const tree = Tree.Parse(source);
        const fields = new FFieldResolver(this.fields);
        const funcs = new FFuncResolver(this.funcs);
        const types = new FTypeResolver(fields, funcs, this.types);
        return this.validateFormula(tree, new Compiler(fields, funcs, types));
    }
    compileFormula(tree, compiler) {
        if (AggFormula.Matches(tree)) {
            return new AggFormula(tree, compiler);
        }
        else if (DateFormula.Matches(tree)) {
            return new DateFormula(tree, compiler);
        }
        else if (FieldFormula.Matches(tree)) {
            return new FieldFormula(tree, compiler);
        }
        else if (NTileFormula.Matches(tree)) {
            return new NTileFormula(tree, compiler);
        }
        else {
            return new GenericFormula(tree, compiler);
        }
    }
    validateFormula(tree, compiler) {
        return this.compileFormula(tree, compiler).validate();
    }
}
